<template>
  <div class="company-div" v-if="companies.length > 0">
    <div class="container">
      <p v-if="homeSetting.company_title" class="heading">{{ homeSetting.company_title }}</p>
      <div v-else>
        <v-skeleton-loader class="bg-transparent mx-auto mb-8 mt-16" type="text, text" width="500"></v-skeleton-loader>
      </div>

      <div class="companies-items">
        <carousel v-bind="options">
          <slide class="slide-item" v-for="company in companies" :key="company.id">
            <img class="img-fluid company-img" :src="company.image_path" alt="company image">
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["homeSetting", "companies"],
  data() {
    return {
      options: {
        loop: true,
        margin: 5,
        centerMode: true,
        autoplay: true,
        autoplayTimeout: 3000,
        paginationEnabled: false,
        autoplayHoverPause: true,
        navigationEnabled: false,
        paginationColor: "#555",
        paginationActiveColor: "#9f762b",
        paginationSize: 5,
        rtl: true,
        perPageCustom: [
          [0, 4],
          [375, 5],
          [425, 6],
          [768, 9],
          [1024, 12],
          [1440, 18],
        ],
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.company-div {
  .heading {
    text-align: center;
    color: #727272;
    font-size: 16px;
    font-weight: 500;
    padding: 20px 0;
    font-style: normal;
    line-height: 24px;
  }

  .companies-items {
    direction: rtl;

    .company-img {
      height: 30px;
      width: auto;
      object-fit: contain;
    }
  }
  @media (max-width: 768px) {
    .heading {
      padding: 32px 0;
    }
  }
}
</style>